import React from "react";
import SimplePage from "../../components/legal/SimplePage";
import { useCurrency } from "../../context/CurrencyContext";

export default function Blog() {
  const { settings } = useCurrency();
  return <SimplePage eyebrow="Company" title="Blog" text={settings?.content_blog} loading={!settings?.content_blog} />;
}
